export default "__VITE_ASSET__Dii4qbvQ__"